function search() {
    /**
     * https://developers.google.com/custom-search/docs/element#javascript
     *
     * Google Custom Search configured with `matrixwebmaster1999`
     */

    //console.log(window.searchUrl);
    $('.search-form').on('submit', function (e) {
        e.preventDefault();
        var searchPhrase = $(this).find('[name=q]').val();
        goToSearchResults(searchPhrase, "");
    });
    function goToSearchResults(searchPhrase, searchFilters) {
        var resultsUrl = window.searchUrl +  '/search-results/#!/';
        console.log(resultsUrl);
        window.location.href = resultsUrl + encodeURIComponent(searchPhrase) + '/page=1/' + searchFilters;
    }
    (function ($) {
        function closeSearch() {
            $(".search-wrap").addClass("animated fadeOutDownBig");
        }

        $(function () {
            $(".search-wrap").on(
                "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                function () {
                    if ($(this).hasClass("fadeIn")) {
                        $(this).removeClass("fadeIn");
                    }

                    if ($(this).hasClass("fadeOutDownBig")) {
                        $(this).removeClass("fadeOutDownBig animated");
                    }
                }
            );

            $(".search-wrap__close").on("click touch", function () {
                closeSearch();
            });

            $(".search-trigger").on("click touch", function () {
                $(".search-wrap").addClass("animated fadeIn");
                $(".search-wrap .search-field").focus();
            });
        });
    })(jQuery);
}

export default search;



// WEBPACK FOOTER //
// ./src/js/partials/search.js